import React from 'react';
import './index.css'; 
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import Home from "./pages/Home";
import FlightDetails from './pages/FlightDetails';
import APropos from './pages/APropos';
import ReservationSheet from './pages/ReservationSheet';
import AdminReservationsApp from './admin/AdminReservationsApp';
import DetailReservationViaEmail from './pages/DetailReservationViaEmail';


function ReservationRoute() {
  const { reference } = useParams();
  return <DetailReservationViaEmail reference={reference} />;
}


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apropos" element={<APropos />} />
        <Route path="/details_offres" element={<FlightDetails />} />
        <Route path="/reservation" element={<ReservationSheet />} />
         <Route path="/manager" element={<AdminReservationsApp />} />
           <Route path="/reservation/:reference" element={<ReservationRoute />} />
          
      </Routes>
    </Router>

    
  );
}

export default App;

